import * as React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { Outcome } from 'gossamer-unified';

export interface FormButtonsProps {
  handleCancel?: () => void;
  handleSubmit: (outcomeId: string) => void;
  outcomes?: Outcome[];
  submitting: boolean;
}

export const FormButtons = (props: FormButtonsProps): React.JSX.Element => {
  const outcomes = props.outcomes || [
    {
      id: 'save',
      label: 'Save',
      nextTasks: [],
      default: true,
    },
  ];

  return (
    <div aria-label="form buttons" className="gap10px">
      {outcomes.map(outcome => (
        <Button
          key={outcome.id}
          onClick={() => {
            props.handleSubmit(outcome.id);
          }}
          size="sm"
          type={outcome.default ? 'submit' : 'button'}
          variant={outcome.variant || (outcome.default ? 'primary' : 'secondary')}
          disabled={props.submitting}
        >
          {props.submitting && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
          {!props.submitting && outcome.label}
        </Button>
      ))}
      {!!props.handleCancel && (
        <Button onClick={props.handleCancel} size="sm" variant="secondary" disabled={props.submitting}>
          {props.submitting && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
          {!props.submitting && 'Cancel'}
        </Button>
      )}
    </div>
  );
};
